import { useSelector } from 'react-redux';
import RetentionListPage, { LIST_COLORS as C } from './RetentionListPage';
import { RETAINED_HEAD } from './retentionTableHeads';
import { getRetainedStudents } from '../../../redux/features/retentionSlice';

// /student-journey/retained — enrolments that renewed at stage 13 (§2.4); View opens their renewal stage.
export default function RetainedStudents() {
  const { retained } = useSelector((state) => state.retention);

  return (
    <RetentionListPage
      title="Retained students"
      icon="solar:cup-star-bold-duotone"
      headers={RETAINED_HEAD}
      fetchThunk={getRetainedStudents}
      resource={retained}
      endpoint="GET /retention/retained"
      openPath={(row) => `/student-journey/${row.course_enrollment_id}/tracking?stage=13`}
      filterParam="period"
      filters={[
        { label: 'This month', value: 'month' },
        { label: 'This quarter', value: 'quarter' },
        { label: 'All time', value: 'all' },
      ]}
      kpis={[
        { key: 'retained', label: 'Retained', icon: 'solar:cup-star-bold-duotone', color: C.green },
        { key: 'retention_rate', label: 'Retention rate', icon: 'solar:pie-chart-2-bold-duotone', color: C.indigo, hint: 'Stage 13 ÷ stage 7' },
        { key: 'upsold', label: 'Upsold', icon: 'solar:graph-up-bold-duotone', color: C.violet },
        { key: 'same_tutor_percent', label: 'Same tutor', icon: 'solar:user-check-rounded-bold-duotone', color: C.blue },
        { key: 'referrals', label: 'Referrals', icon: 'solar:users-group-rounded-bold-duotone', color: C.teal },
      ]}
    />
  );
}
